var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurClient6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 158,
    viewBox: "0 0 235 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 233,
    height: 157,
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M78.1381 76.7828V94.5046H72.0629V70.0172H59.5V64.9495H66.3004C72.8359 64.9495 78.1337 70.2473 78.1337 76.7828H78.1381Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M90.666 71.7979H96.6066V94.5005H90.666V71.7979Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M98.5742 71.7979H116.209V76.4139H98.5742V71.7979ZM104.419 71.7979H110.36V94.5049H104.419V71.7979Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M145.562 71.7981V79.5017C143.586 81.2648 141.619 82.954 139.621 84.3263V71.7981H145.562Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M154.544 82.116V94.5008H148.604V86.9752C151.283 84.5521 154.444 82.1854 154.544 82.116Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M136.24 89.1638C136.023 89.2897 135.793 89.4113 135.554 89.5242C134.308 90.0973 132.844 90.4056 131.164 90.436C132.91 90.3882 134.594 89.9237 136.24 89.1682V89.1638Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M174.872 80.6134V94.5007H168.932V81.6643C168.932 79.7449 168.467 78.3379 167.538 77.439C166.613 76.5401 165.097 76.0928 162.995 76.0928C162.9 76.0928 162.796 76.0928 162.7 76.0928C161.623 76.1189 160.62 76.2926 159.691 76.6052C159.691 76.6052 159.689 76.6052 159.686 76.6052C157.936 77.1394 156.23 78.0556 154.549 79.2107C154.436 79.2889 151.227 81.7033 148.609 84.07C147.597 84.9863 146.581 85.9199 145.56 86.8405C143.645 88.5689 141.713 90.232 139.733 91.6043C136.823 93.6192 133.805 95.0001 130.578 95.0001C130.322 95.0001 130.079 94.9914 129.845 94.9784C129.562 94.9914 129.271 95.0001 128.976 95.0001C126.722 95.0001 124.673 94.5051 122.836 93.515C120.99 92.5249 119.531 91.1396 118.45 89.3592C117.369 87.5788 116.83 85.5117 116.83 83.1668C116.83 80.8218 117.377 78.6766 118.472 76.9049C119.566 75.1418 121.055 73.7652 122.927 72.7751C124.794 71.7807 126.926 71.29 129.297 71.29C131.916 71.29 134.026 71.8198 135.624 72.8707C136.12 73.1964 136.575 73.5568 136.988 73.9563V77.5823C136.554 77.2653 136.067 76.9874 135.533 76.7529C134.235 76.1883 132.693 75.9104 130.895 75.9104C128.372 75.9104 126.405 76.5705 125.007 77.895C123.604 79.2194 122.905 80.9781 122.905 83.1668C122.905 84.6259 123.24 85.9026 123.908 86.9838C124.577 88.0608 125.515 88.9076 126.714 89.5199C127.917 90.1235 129.31 90.4318 130.891 90.4318C130.982 90.4318 131.074 90.4318 131.165 90.4318C132.845 90.4014 134.309 90.0974 135.555 89.5199C135.794 89.407 136.024 89.2854 136.241 89.1594C136.245 89.1551 136.254 89.1508 136.258 89.1464C137.379 88.6297 138.486 87.9739 139.581 87.2183C139.594 87.214 139.602 87.2053 139.62 87.1923C141.617 85.82 143.584 84.1308 145.56 82.3677C146.572 81.4645 147.588 80.5439 148.609 79.6406C150.545 77.921 152.513 76.2622 154.549 74.8769C157.667 72.7578 160.946 71.2943 164.528 71.2943C164.715 71.29 164.906 71.2856 165.097 71.2856C166.5 71.2856 167.794 71.468 168.979 71.8328C170.169 72.1976 171.203 72.7578 172.084 73.522C172.97 74.2863 173.652 75.2547 174.138 76.4228C174.625 77.5953 174.872 78.9893 174.872 80.6003V80.6134Z",
    fill: "#D0F500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.57,
    d: "M162.7 76.0969C161.68 76.1273 160.677 76.3053 159.691 76.6093C160.625 76.2967 161.624 76.123 162.7 76.0969Z",
    fill: "#FF0000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M93.7055 69.6258C95.5351 69.6258 97.0184 68.1425 97.0184 66.3129C97.0184 64.4832 95.5351 63 93.7055 63C91.8758 63 90.3926 64.4832 90.3926 66.3129C90.3926 68.1425 91.8758 69.6258 93.7055 69.6258Z",
    fill: "#D0F500"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M87.9899 64.9497H78.1367V70.0174H87.9899V64.9497Z",
    fill: "#101828"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M104.418 65.5881V71.7971H110.358C110.358 71.7971 110.358 71.4324 110.358 65.5881H104.418Z",
    fill: "#101828"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurClient6);
export default __webpack_public_path__ + "static/media/our-client-6.2de0624fc35c55264e0d358e38cf8c6a66071a7feaf17b0a8a716ab05dfbcf00.svg";
export { ForwardRef as ReactComponent };